import type { BoardEdge } from "@archlang/scene/board";

/** Service pair for a board edge = the top-level module of each endpoint's
 *  qualified path (`Parent.Child` → `Parent`). Returns null for edges without
 *  resolved endpoints (aspect tethers, stubs). Shared by the traffic overlay and
 *  the telemetry edge-health layer so both key edges identically. */
export function edgeServicePair(e: BoardEdge): readonly [string, string] | null {
  const d = e.details[0];
  if (!d) return null;
  const from = d.fromPath.split(".")[0];
  const to = d.toPath.split(".")[0];
  if (!from || !to) return null;
  return [from, to];
}
